import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form"

import "./CardCadastroMetasServico.css"

export default function CardCadastroMetasServico({ tipoServico, isEven, modoInsercao }) {
    
    const { register, setValue } = useFormContext();

    const formatValue = (value, type) => {
        let formattedValue = value;

        formattedValue = formattedValue.replace(/[^\d,]/g, '')
        formattedValue = formattedValue.replace(/(?<!\d),/g, '')
        const firstCommaIndex = formattedValue.indexOf(',');
        formattedValue = formattedValue.replace(/,/g, (match, offset) => {
            return offset === firstCommaIndex ? match : '';
        });

        if(formattedValue === '')
            return formattedValue

        if(type === 'percentual') {
            formattedValue = Math.min(Math.max(parseInt(formattedValue), 0), 100).toString();

            return formattedValue;
        } else {
            const firstCommaIndex = formattedValue.indexOf(',');
            let preCommas = parseInt(formattedValue.substring(0, firstCommaIndex === -1 ? formattedValue.length : firstCommaIndex));
            if(preCommas > 999999999)
                preCommas = 999999999;
            const postCommas = firstCommaIndex === -1 ? '' : formattedValue.substring(firstCommaIndex, firstCommaIndex+3)
            
            formattedValue = preCommas.toLocaleString('pt') + postCommas;

            return formattedValue;
        }
    }
    
    const inputWatcher = useWatch({name: `${tipoServico.idtiposervico}.${modoInsercao}`});

    useEffect(() => {
        if(typeof inputWatcher === 'string'){
            setValue(`${tipoServico.idtiposervico}.${modoInsercao}`, formatValue(inputWatcher, modoInsercao));
        }
    }, [ inputWatcher ]);

    return <>
        <div className={`card-cadastro-metas-servico ${isEven ? 'par' : 'impar'}`}>
            <h2>{tipoServico.descricao}</h2>
            <div className="card-cadastro-metas-servico-body">
                {modoInsercao === 'percentual' ? (
                    <div>
                        <label htmlFor="">Percentual:</label>
                        <input 
                            type="text" 
                            { ... register(`${tipoServico.idtiposervico}.percentual`) }
                        />
                    </div>
                ) : (
                    <div>
                        <label htmlFor="">Absoluto:</label>
                        <input 
                            type="text" 
                            { ... register(`${tipoServico.idtiposervico}.absoluto`) }
                        />
                    </div>
                )}
            </div>
        </div>
    </>
}